import { MenuItem, Select } from '@mui/material';
import lang from '../../i18n/lang';
import { AttendanceStatusEnum } from '../../dtos/participantdata/scanmodule/attendance-status.enum';

interface AttendanceActionSelectorProps {
  value: string | null;
  onChange: (action: string | null) => void;
}

const AttendanceActionSelector = ({
  value,
  onChange,
}: AttendanceActionSelectorProps) => {
  return (
    <Select
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <MenuItem value={AttendanceStatusEnum.CHECKED_IN}>{lang('scan.checkin')}</MenuItem>
      <MenuItem value={AttendanceStatusEnum.CHECKED_OUT}>{lang('scan.checkout')}</MenuItem>
    </Select>
  );
};

export default AttendanceActionSelector;
